import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_outbound_header_pick_slip_reportService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { orderId: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, LookupCode?: string, RequestedDeliveryDate?: string, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { ExpectedDate?: string, FobLocation?: string, GrossWeight?: number, LookupCode?: string, NetWeight?: number, Notes?: string, ShippedDate?: string, Wave?: { Id?: number, PickSlips?: { Id?: number, LookupCode?: string }[], Warehouse?: { Name?: string } }, Carrier?: { Name?: string } }, Order?: { LookupCode?: string, Project?: { LookupCode?: string, Owner?: { LookupCode?: string } }, PreferredCarrier?: { Name?: string } } }[], Project?: { LookupCode?: string, Owner?: { LookupCode?: string } } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.orderId)) {
      $missingRequiredInParams.push('\'orderId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { orderId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, LookupCode?: string, RequestedDeliveryDate?: string, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { ExpectedDate?: string, FobLocation?: string, GrossWeight?: number, LookupCode?: string, NetWeight?: number, Notes?: string, ShippedDate?: string, Wave?: { Id?: number, PickSlips?: { Id?: number, LookupCode?: string }[], Warehouse?: { Name?: string } }, Carrier?: { Name?: string } }, Order?: { LookupCode?: string, Project?: { LookupCode?: string, Owner?: { LookupCode?: string } }, PreferredCarrier?: { Name?: string } } }[], Project?: { LookupCode?: string, Owner?: { LookupCode?: string } } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.orderId)) {
      $missingRequiredInParams.push('\'orderId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { orderId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, LookupCode?: string, RequestedDeliveryDate?: string, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { ExpectedDate?: string, FobLocation?: string, GrossWeight?: number, LookupCode?: string, NetWeight?: number, Notes?: string, ShippedDate?: string, Wave?: { Id?: number, PickSlips?: { Id?: number, LookupCode?: string }[], Warehouse?: { Name?: string } }, Carrier?: { Name?: string } }, Order?: { LookupCode?: string, Project?: { LookupCode?: string, Owner?: { LookupCode?: string } }, PreferredCarrier?: { Name?: string } } }[], Project?: { LookupCode?: string, Owner?: { LookupCode?: string } } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.orderId)) {
      $missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      orderId: number    }) {
        if(isNil($inParams.orderId)) {
          return true; 
        }
      return false;
    }
}
